export enum StatusType {
    ALL, EXPIRED, NOT_EXPIRED
}

export const StatusTypeList = [
    {
        type: StatusType.EXPIRED,
        name: "모집중"
    },
    {
        type: StatusType.NOT_EXPIRED,
        name: "마감"
    }
];

export enum ListenerStatusType {
    NOT_PAID, PAID , CANCELED
}

export class ListenerStatusInfo {
    static statusTypes: string[] = [
        "미입금", "결제완료", "결제취소"
    ]

    static ordinalToName = (ordinal: number): string => {
        switch (ordinal) {
            case 0:
                return "미입금";
            case 1:
                return "결제완료";
            case 2:
                return "결제취소";
            case 3:
                return "환불요청";
            case 4:
                return "환불완료";
        }
        return "";
    }
}

export enum PaymentType {
    CARD, TRANSFER
}

export class PaymentTypeInfo {
    static ordinalToName = (ordinal: number): string => {
        switch (ordinal) {
            case 0:
                return "카드";
            case 1:
                return "계좌이체";
        }
        return "전체";
    }
}